import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user.email) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="flex min-h-[100dvh] items-center justify-center caneat-doodle-bg px-5">
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm rounded-3xl bg-white p-7 shadow-2xl"
      >
        <div className="mb-6 flex flex-col items-center text-center">
          <img src="/brand/caneat-logo-orange.png" alt="CAN'EAT" className="h-20 w-auto" />
          <h1 className="caneat-title mt-4 text-2xl text-caneat-ink">CAN'EAT ADMIN</h1>
          <p className="mt-1 text-sm font-medium text-caneat-muted">{t("admin_login_sub")}</p>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-caneat-muted">{t("email")}</label>
            <input
              data-testid="admin-email"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full rounded-xl border-2 border-caneat-cream bg-caneat-pageCream px-4 py-3 text-sm font-semibold text-caneat-ink outline-none focus:border-caneat-orange"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-caneat-muted">{t("password")}</label>
            <input
              data-testid="admin-password"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full rounded-xl border-2 border-caneat-cream bg-caneat-pageCream px-4 py-3 text-sm font-semibold text-caneat-ink outline-none focus:border-caneat-orange"
            />
          </div>
          {error && <p className="text-sm font-bold text-red-500" data-testid="admin-login-error">{error}</p>}
          <button
            data-testid="admin-login-submit"
            type="submit" disabled={loading}
            className="mt-2 flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-caneat-orange text-base font-extrabold uppercase tracking-wide text-white shadow-lg disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Lock className="h-4 w-4" /> {t("login")}</>}
          </button>
          <p className="text-center text-xs font-medium text-caneat-muted">
            Mot de passe oublié ? Demande un lien de réinitialisation à un Super Admin.
          </p>
        </form>
      </motion.div>
    </div>
  );
}
